module.exports = __webpack_public_path__ + "static/img/184_phase_function_Paper_PointsHejduk_Prediction.59b4f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/184_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5hV1
// module chunks = 0